import {
  Box,
  BreadcrumbItem,
  Breadcrumbs,
  HeadingBlock,
} from "@qws-org/ui-kit";
import type { FC } from "react";

import { useClientContext } from "~/contexts/client-context";
import type { DetailedPromotion } from "~/core/deprecated/promotions";
import { TopperWithoutReg } from "~/features-deprecated/banner/TopperWithoutReg";

type DetailedPromoProps = {
  promotion?: DetailedPromotion;
  playUrl: string;
  analytics: {
    logInMain: () => void;
    createAccountMain: () => void;
  };
};

const breadcrumbsMap: Record<string, string> = {
  "lucky-wheel": "Lucky wheel",
  "welcome-winner": "Welcome Winner",
  "tournament-guarantee": "Tournament GTD",
  "spin-and-win": "Spin&Win",
  series: "Series",
  cryptobonus: "First Crypto Deposit",
  flipout: "Flipouts",
};

export const DetailedPromo: FC<DetailedPromoProps> = ({
  promotion,
  playUrl,
  analytics: { createAccountMain, logInMain },
}) => {
  const { language } = useClientContext();

  return (
    <>
      <TopperWithoutReg
        topperTitle={promotion?.topperTitle[language]}
        playNowLink={playUrl}
        topperBackground={{
          imageVariants: promotion?.topperImage[language],
          mobileImageVariants: promotion?.topperMobileImage?.[language],
        }}
        analytics={{ createAccountMain, logInMain }}
      />
      <Box className="max-w-[1272px] " m={{ mx: "auto" }}>
        <Breadcrumbs
          className="w-full"
          p={16}
          m={{ mx: "auto" }}
          md={{ p: { px: 16, pt: 64, pb: 40 } }}
          aria-label="Navigation"
        >
          <BreadcrumbItem href={"/"} variant="active">
            {"Home"}
          </BreadcrumbItem>

          <BreadcrumbItem href={"promotions"} variant="active">
            {"Features"}
          </BreadcrumbItem>

          {promotion?.id && (
            <BreadcrumbItem href="" variant="disabled">
              {breadcrumbsMap[promotion.id] ?? promotion.id}
            </BreadcrumbItem>
          )}
        </Breadcrumbs>
        <HeadingBlock
          className=" has-[img]:pb-0"
          p={{ py: 24, px: 16 }}
          md={{ p: { pt: 0, pb: 64, px: 16 } }}
          d={{ p: { pt: 0, pb: 64, px: 16 } }}
          m={{ mx: "auto" }}
          title={
            promotion?.pageTitle
              ? promotion.pageTitle[language]
              : promotion?.title[language]
          }
          description={promotion?.description[language]}
        />
        {promotion?.detailTitle && (
          <HeadingBlock
            size="medium"
            title={promotion?.detailTitle?.[language]}
            description={promotion?.detailDescription?.[language]}
            p={{ py: 24, px: 16 }}
            md={{ p: { py: 64 } }}
          />
        )}
      </Box>
    </>
  );
};
